import React, { memo, Children, PropsWithChildren } from 'react'
import { AccordionProps } from './Accordion.types'
import styles from './Accordion.module.css'

const Accordion = ({
  children,
  ...rest
}: PropsWithChildren<AccordionProps>) => (
  <div {...rest}>
    <div className={styles.accordionContainer}>
      {Children.map(children, (child, index) => (
        <div className={styles.accordionListItem} key={index}>
          {child}
        </div>
      ))}
    </div>
  </div>
)

export default memo(Accordion)
